export enum ProductTypeEnum {
  PRODUCT = "product",
  BUNDLE = "bundle",
  SERVICE = "service",
  UPDATE = "update",
}

export enum ErrorsEnum {
  NA = "n/a",
}

export enum B2BEntityEnum {
  ACQUISITION = "acquisition",
  EDIT_QUOTE = "edit_quote",
  FORCE_ACQUISITION = "force_acquisition",
  PRODUCT_SELECT = "product_select",
  NEW_QUOTE = "new_quote",
}

// Values correspond to EasyProductSolution#internal_name
// plugins/easyproject/easy_plugins/easy_crm_2_0/easy_b2b/app/models/easy_product_solution.rb
export enum QuoteSolutionEnum {
  SERVER = "server",
  CLOUD = "cloud",
  SERVICE = "service",
  SERVER_SUBSCRIPTION = "server_subscription",
}

interface SolutionLike {
  id: string;
  internalName?: string | null;
}

/**
 * Resolves a solution database ID to its internalName using the available solutions list.
 * Used to compare solution types without relying on hardcoded database IDs.
 */
export function getSolutionInternalName(
  solutionId: string | undefined | null,
  availableSolutions: SolutionLike[] | undefined
): string | null {
  if (!solutionId || !availableSolutions) return null;
  return availableSolutions.find(s => s.id === solutionId)?.internalName ?? null;
}

// plugins/easyproject/easy_plugins/easy_crm_2_0/easy_crm/app/models/easy_crm_case_payment_method.rb
export enum CrmPaymentMethodEnum {
  BANK_TRANSFER = "243",
  CLIENT_ZONE = "246",
}

export enum SubscriptionsEnum {
  YEAR = "yearly",
  MONTH = "monthly",
  NONE = "none",
}
